module.exports = __webpack_public_path__ + "img/whataspp-mobile.4052ff89.svg";